import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("ellipse", {
      cx: "12",
      cy: "13",
      rx: "6.5",
      ry: "5"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "9.5",
      cy: "12",
      r: ".8",
      fill: "currentColor",
      stroke: "none"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "14.5",
      cy: "12",
      r: ".8",
      fill: "currentColor",
      stroke: "none"
    }, null, -1),
    _createElementVNode("path", { d: "M8 8.5C6.5 6 4.5 5.5 4 7m12 1.5c1.5-2.5 3.5-3 4-1.5M10.5 15h3" }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "clinic-feature-rodents"}) } }